import React, {memo} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {TscThemeName, TscThemeNames, TscStyles, Spinner} from '@techsmith/tsc-cloud-style-guide';
import {StyledWarning} from '../util/StyledElements';
import {useTscTheme} from '../../context/themeProvider';

const LoadingSpinner = styled.div<{theme: TscThemeNames}>`
   position: absolute;
   display: flex;
   align-items: center;
   top: -0.5rem;
   bottom: -0.5rem;
   left: -0.5rem;
   right: -0.5rem;
   z-index: 3;
   opacity: .9;
   background: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.medium : TscStyles.color.ui.dawn.light};
`;

const TabBody = styled.div`
   position: relative;
   margin-top: 12px;
   padding: 0 16px 8px 16px;
`;

export const TabContentWrapperBase: React.FC<ITabContentWrapperProps> = ({children, showSpinner, showError, customErrorMessage}) => {
   const {t} = useTranslation();
   const theme = useTscTheme();

   return (
      <TabBody data-test-id="tab-content-wrapper">
         {showError && (
            <StyledWarning data-test-id="styled-warning">
               {customErrorMessage ? customErrorMessage : t('general.errorText')}
            </StyledWarning>
         )}
         {children}
         {showSpinner && (
            <LoadingSpinner
               data-test-id="loading-spinner"
               theme={theme}
            >
               <Spinner />
            </LoadingSpinner>
         )}
      </TabBody>
   );
};

export interface ITabContentWrapperProps {
   children?: React.ReactNode;
   showSpinner: boolean;
   showError: boolean;
   customErrorMessage?: string;
}

export default memo(TabContentWrapperBase);
